import { FileRoutesByFullPath } from '@providers';
import { UseNavigateResult } from '@tanstack/react-router';
import { DataTableSortStatus } from 'mantine-datatable';
import { getSortStatus, getSortValue, onSortStatusChange } from './helpers';

type SortingConfigType = {
  accessorOptions?: string[];
  defaultAccessor?: string;
  defaultDirection?: 'asc' | 'desc';
};

type UseTableSortingOptionsType = {
  navigateFn: UseNavigateResult<keyof FileRoutesByFullPath>;
  searchParams: Record<string, unknown>;
  config: SortingConfigType;
  tableId?: string;
};

type SortingControllerType = {
  sortStatus: DataTableSortStatus;
  onSortStatusChange: (newSortStatus: DataTableSortStatus) => void;
};

export const useTableSorting = ({
  navigateFn,
  searchParams,
  config,
  tableId,
}: UseTableSortingOptionsType): SortingControllerType => {
  const {
    accessorOptions = [],
    defaultAccessor = '',
    defaultDirection = 'asc',
  } = config;

  const sortValue = getSortValue({
    searchParams,
    tableId,
    defaultAccessor,
    defaultDirection,
  });

  const sortStatus = getSortStatus({
    sortValue,
    defaultAccessor,
    defaultDirection,
  });

  const onSortStatusChangeFn = (newSortStatus: DataTableSortStatus) => {
    onSortStatusChange({
      newSortStatus,
      accessorOptions,
      defaultAccessor,
      navigateFn,
      tableId,
    });
  };

  return {
    sortStatus,
    onSortStatusChange: onSortStatusChangeFn,
  };
};
